import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ProfileService {

  constructor(private _http: HttpClient) { }

  public UserExists(emailAddress: string, eventKey: string, token: string): Observable<boolean> {
    const url = `/api/profile/v1?email=${encodeURIComponent(emailAddress)}&eventKey=${eventKey}`;
    return this._http.get<boolean>(url, { headers: { Token: token } });
  }
}
